export default __webpack_public_path__ + "static/media/img-page2.1490b80b.png";